import React from "react";
import { useSelector } from "react-redux";

const CpDbHOC = (Component) => {
  return function Wrapper(props) {
    const user = useSelector(({ auth }) => auth?.user);
    const isCpDb = !!user?.cp_db_id;

    return <Component {...props} isCpDb={isCpDb} />;
  };
};

export default CpDbHOC;
